import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DateRangePicker = ({ onRangeChange }) => {
  const [selectedRange, setSelectedRange] = useState('7days');
  const [isOpen, setIsOpen] = useState(false);

  const ranges = [
    { value: 'today', label: 'Today', icon: 'Calendar' },
    { value: '7days', label: 'Last 7 Days', icon: 'Calendar' },
    { value: '30days', label: 'Last 30 Days', icon: 'Calendar' },
    { value: '90days', label: 'Last 90 Days', icon: 'Calendar' },
    { value: 'custom', label: 'Custom Range', icon: 'CalendarRange' }
  ];

  const handleRangeSelect = (value) => {
    setSelectedRange(value);
    setIsOpen(false);
    if (onRangeChange) {
      onRangeChange(value);
    }
  };

  const selectedLabel = ranges?.find(r => r?.value === selectedRange)?.label || 'Select Range';

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-lg hover:bg-muted transition-colors text-sm font-medium text-foreground"
      >
        <Icon name="Calendar" size={16} />
        <span>{selectedLabel}</span>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={16} />
      </button>
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-card border border-border rounded-lg shadow-lg z-20 overflow-hidden">
            {ranges?.map((range) => (
              <button
                key={range?.value}
                onClick={() => handleRangeSelect(range?.value)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-muted transition-colors ${
                  selectedRange === range?.value ? 'bg-primary/10 text-primary' : 'text-foreground'
                }`}
              >
                <Icon name={range?.icon} size={16} />
                <span>{range?.label}</span>
                {selectedRange === range?.value && (
                  <Icon name="Check" size={16} className="ml-auto" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DateRangePicker;